import { PrivacyNotice } from '../src/components'
import Footers from '../src/components/Footer'
import Header from '../src/components/Header'

export default function ContactPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <PrivacyNotice />
      </div>
      <Footers />
    </>
  )
}
